<template>
  <div></div>
</template>

<script>
import {
  Instantiate3DUIFunc,
  CloseBrowserFunc,
  OpenBrowserFunc,
  LoadPathFromJSFunc,
  StopPathFunc,
  CamFixFunc,
  CameraMove,
  IsShowBuildingsFunc,
  RoadHeatLineFunc,
  ShowHeatLineFunc,
  HideHeatLineFunc,
} from "@/assets/js/unity3D/index.js";
import roadUnityFly from "./unityFly.js";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';
export default {
  data() {
    return {
      streetList: {
        "42_62": {
          x: 1209.68457,
          y: 0.0537261963,
          z: -226.668945,
          name: "于唐线西南段(东西向)",
        },
        "42_63": {
          x: 525.882935,
          y: 0.0537281036,
          z: -143.818848,
          name: "于唐线西南段(南北向)",
        },
        "42_61": {
          x: 1680.39868,
          y: -0.7270336,
          z: 75.24078,
          name: "于唐线南段",
        },
        "42_3": {
          x: 1954.69458,
          y: 0.0537261963,
          z: 176.776062,
          name: "唐爽路东段",
        },
        "42_4": {
          x: 1596.19434,
          y: 0.0537281036,
          z: 147.3487,
          name: "唐爽路中东段",
        },
        "42_2": {
          x: 1323.84668,
          y: 0.05372429,
          z: 126.1875,
          name: "唐爽路中段",
        },
        "42_1": {
          x: 363.546631,
          y: 0.0537261963,
          z: 55.6340942,
          name: "唐爽路中西段",
        },
        "42_5": {
          x: -466.343384,
          y: 0.0537261963,
          z: -3.36132813,
          name: "唐爽路西段",
        },
        "42_8": {
          x: 1405.34424,
          y: 0.0537261963,
          z: 239.22876,
          name: "南环路东段",
        },
        "42_7": {
          x: 914.4064,
          y: 8.0,
          z: 212.662659,
          name: "南环路中段",
        },
        "42_6": {
          x: 441.071655,
          y: 8.0,
          z: 171.988647,
          name: "南环路西段",
        },
        "42_25": {
          x: 1196.86548,
          y: 0.0537261963,
          z: 367.93103,
          name: "经四路南段",
        },
        "42_23": {
          x: 1127.31812,
          y: 0.05372429,
          z: 1201.96167,
          name: "经四路中段",
        },
        "42_22": {
          x: 1103.97437,
          y: 8.0,
          z: 1505.49072,
          name: "经四路中北段",
        },
        "42_21": {
          x: 1092.17651,
          y: 0.05372429,
          z: 1730.13208,
          name: "经四路北段",
        },
        "42_14": {
          x: 226.827026,
          y: 8.0,
          z: 271.124146,
          name: "西环路南段",
        },
        "42_11": {
          x: 1399.37817,
          y: 0.0537281036,
          z: 533.009033,
          name: "纬一路东段",
        },
        "42_10": {
          x: 999.1365,
          y: 0.0537261963,
          z: 497.1267,
          name: "纬一路中段",
        },
        "42_9": {
          x: 513.9275,
          y: 8.0,
          z: 426.7168,
          name: "纬一路西段",
        },
        "42_54": {
          x: 129.094849,
          y: 0.0537261963,
          z: 411.249756,
          name: "环厂西路南段",
        },
        "42_53": {
          x: 88.76575,
          y: 0.0537261963,
          z: 916.3563,
          name: "环厂西路中段",
        },
        "42_52": {
          x: 67.6012,
          y: 0.05372429,
          z: 1267.16187,
          name: "环厂西路北段",
        },
        "42_60": {
          x: 1639.81763,
          y: 8.0,
          z: 767.6256,
          name: "于唐线中南段",
        },
        "42_59": {
          x: 1611.30518,
          y: 0.0537281036,
          z: 1168.4563,
          name: "于唐线中段",
        },
        "42_58": {
          x: 1579.898,
          y: 8.0,
          z: 1562.53174,
          name: "于唐线中北段",
        },
        "42_57": {
          x: 1547.18628,
          y: -0.206016541,
          z: 2057.14258,
          name: "于唐线北段",
        },
        "42_34": {
          x: 1584.4436,
          y: 0.0537261963,
          z: 930.546,
          name: "东环路南段",
        },
        "42_33": {
          x: 1531.261,
          y: 8.0,
          z: 1613.55518,
          name: "东环路北段",
        },
        "42_24": {
          x: 1156.01172,
          y: 8.0,
          z: 783.921753,
          name: "经四路中南段",
        },
        "42_18": {
          x: 803.249756,
          y: 0.05372429,
          z: 592.0408,
          name: "经二路南段",
        },
        "42_17": {
          x: 771.682,
          y: 8.0,
          z: 833.3502,
          name: "经二路北段",
        },
        "42_13": {
          x: 177.440063,
          y: 0.0537261963,
          z: 759.828,
          name: "西环路中段",
        },
        "42_12": {
          x: 134.017456,
          y: 0.0537261963,
          z: 1282.41821,
          name: "西环路北段",
        },
        "42_20": {
          x: 1075.27271,
          y: 8.0,
          z: 843.082153,
          name: "经三路南段",
        },
        "42_19": {
          x: 1006.573,
          y: 0.0537261963,
          z: 951.2848,
          name: "经三路北段",
        },
        "42_16": {
          x: 946.569336,
          y: 8.0,
          z: 1073.66614,
          name: "纬三路东段",
        },
        "42_15": {
          x: 624.975464,
          y: 0.0537261963,
          z: 1019.69116,
          name: "纬三路西段",
        },
        "42_29": {
          x: 540.059448,
          y: 8.0,
          z: 1109.13367,
          name: "经一路南段",
        },
        "42_28": {
          x: 527.5515,
          y: 0.0537261963,
          z: 1343.7063,
          name: "经一路北段",
        },
        "42_27": {
          x: 1337.53979,
          y: 8.0,
          z: 1370.979,
          name: "纬四路东段",
        },
        "42_26": {
          x: 877.7136,
          y: 8.0,
          z: 1326.41626,
          name: "纬四路西段",
        },
        "42_30": {
          x: 313.606567,
          y: 8.0,
          z: 1450.353,
          name: "北环路西段",
        },
        "42_31": {
          x: 799.088135,
          y: 8.0,
          z: 1572.1001,
          name: "北环路中段",
        },
        "42_32": {
          x: 1298.25708,
          y: 8.0,
          z: 1700.05273,
          name: "北环路东段",
        },
        "42_47": {
          x: 439.9469,
          y: 8.0,
          z: 1528.97729,
          name: "新北经二路南段",
        },
        "42_46": {
          x: 424.489258,
          y: 8.0,
          z: 1669.31226,
          name: "新北经二路中段",
        },
        "42_45": {
          x: 411.687134,
          y: 8.0,
          z: 1949.48071,
          name: "新北经二路北段",
        },
        "42_35": {
          x: 265.5796,
          y: 0.0537261963,
          z: 1558.35376,
          name: "新北纬一路",
        },
        "42_65": {
          x: 294.887817,
          y: 8.0,
          z: 1659.73853,
          name: "新北经一路南段",
        },
        "42_64": {
          x: 269.367432,
          y: 8.0,
          z: 1941.89526,
          name: "新北经一路北段",
        },
        "42_44": {
          x: 103.531982,
          y: 8.0,
          z: 1457.35327,
          name: "新北西路南段",
        },
        "42_43": {
          x: 63.72046,
          y: 0.0537261963,
          z: 1819.34937,
          name: "新北西路北段",
        },
        "42_36": {
          x: 351.996338,
          y: 8.0,
          z: 1761.36987,
          name: "新北纬二路西段",
        },
        "42_37": {
          x: 755.27356,
          y: 8.0,
          z: 1794.2749,
          name: "新北纬二路中段",
        },
        "42_38": {
          x: 1304.95483,
          y: 8.0,
          z: 1847.071,
          name: "新北纬二路东段",
        },
        "42_50": {
          x: 1526.80664,
          y: 0.05372429,
          z: 1807.86621,
          name: "新北东路南段",
        },
        "42_49": {
          x: 1514.612,
          y: 0.0537261963,
          z: 1996.123,
          name: "新北东路中段",
        },
        "42_48": {
          x: 1500.4104,
          y: 0.0537261963,
          z: 2186.46777,
          name: "新北东路北段",
        },
        "42_39": {
          x: 1098.18872,
          y: 8.0,
          z: 2086.87817,
          name: "第一轧钢厂北路",
        },
        "42_40": {
          x: 1407.46362,
          y: 0.0537261963,
          z: 2251.95459,
          name: "新北纬三路东段",
        },
        "42_41": {
          x: 914.7438,
          y: 8.0,
          z: 2209.705,
          name: "新北纬三路中段",
        },
        "42_42": {
          x: 224.978271,
          y: 0.0537261963,
          z: 2138.778,
          name: "新北纬三路西段",
        },
        "42_56": {
          x: 1884.41333,
          y: -0.13403511,
          z: 2186.376,
          name: "于唐线东北段（东西向）",
        },
        "42_55": {
          x: 2159.226,
          y: 0.0537261963,
          z: 2352.594,
          name: "于唐线东北段（南北向）",
        },
        "42_51": {
          x: 152.273681640625,
          y: 64.87371826171875,
          z: 2319.709716796875,
          name: "环厂北路",
        },
      },
      roadData: [],
      browserList: [],
      floorBrowserList: [],
      nowShowList: [],
      onceShowCount: 5,
      nowTravelRoad: 0,
      timer: null,
      // 是否正在巡游
      isTravelNow: false,
      timerTravel: null,
      timerStop: null,
      basePosition: {
        latitude: 39.499842697084269,
        longitude: 118.27231258110078,
        xDeg: -38.2060852,
        yDeg: 14.3999968,
        distance: 1084.51379,
      },
      HLValueList: {
        干燥: 100,
        中等: 51,
        湿润: 1,
      },
      // 无清洁数据的线路
      hideHLRoad: [
        "42_2",
        "42_3",
        "42_4",
        "42_5",
        "42_55",
        "42_56",
        "42_57",
        "42_58",
        "42_59",
        "42_60",
        "42_61",
        "42_62",
        "42_63",
      ],
    };
  },
  inject: ["changeIsShowCarInfo"],
  mounted() {
    this.getAllRoadList();
    window.addEventListener("mousemove", this.stopTravel, false);
    CameraMove(this.basePosition);
    this.browserList &&
      this.browserList.forEach((i) => {
        CloseBrowserFunc(i + "Road");
      });
  },
  unmounted() {
    this.clearTimer(this.timer);
    this.clearTimer(this.timerTravel);
    this.clearTimer(this.timerStop);

    this.browserList.forEach((i) => {
      CloseBrowserFunc(i + "Road");
    });
    window.removeEventListener("mousemove", this.stopTravel);
  },
  methods: {
    clearTimer(timer) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    },
    // 获取道路列表
    async getAllRoadList() {
      try {
        const getRoadInfoList =
          CONFIG.requestName + this.$apiOpt.getRoadInfoList;
        let res = await this.$apiUtils.get(getRoadInfoList, {
          customerId: this.$store.state.customerId,
        });
        if (res) {
          this.roadData = res;
          this.getRoundAnimate();
          this.stopTravel();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 轮询显隐道路提示板
    getRoundAnimate() {
      this.clearTimer(this.timer);
      if (this.roadData) {
        this.hideNowShowRoad();
        this.getNowShowRoad();
      }
      if (!this.isTravelNow) {
        this.timer = setTimeout(() => {
          this.getRoundAnimate();
        }, 10 * 1000);
      }
    },
    // 隐藏道路提示板
    hideNowShowRoad() {
      this.nowShowList = this.nowShowList.map((i) => {
        if (i) {
          CloseBrowserFunc(i + "Road");
        }
        return "";
      });
    },
    // 获取并渲染道路提示板
    getNowShowRoad() {
      let roadJson = {
        data: [],
      };
      let HLJson = this.roadData.map((i) => {
        return {
          roadID: i.modelId,
          value: -1,
        };
      });
      this.hideHLRoad.forEach((i) => {
        HLJson.push({
          roadID: i,
          value: -1,
        });
      });
      Array.from(
        {
          length: this.isTravelNow
            ? roadUnityFly[this.nowTravelRoad].include.length
            : this.onceShowCount,
        },
        (v, k) => {
          let num = 0,
            roadItemId = null;
          if (this.isTravelNow) {
            roadItemId = this.nowShowList[k] =
              roadUnityFly[this.nowTravelRoad].include[k];
          } else {
            // 随机ID
            num = (this.roadData.length * Math.random()).toFixed(0);
            roadItemId = this.nowShowList[k] =
              this.roadData[num] && this.roadData[num].modelId;
          }

          // 是否为当前需要显示道路&&此道路存在
          if (roadItemId && this.streetList[roadItemId]) {
            HLJson.forEach((i) => {
              if (i.roadID == roadItemId) {
                i.value = this.HLValueList[this.roadData[num].dryWetStatus];
              }
            });
            // 未渲染的道路就渲染 已渲染的道路就直接打开
            if (!this.browserList.includes(roadItemId)) {
              let x = Number(this.streetList[roadItemId].x).toFixed(0);
              let z = Number(this.streetList[roadItemId].z).toFixed(0);
              //url: `http://localhost:5500/standard/page/shedDialogRF/mathRoad/roadDetail.html?modelId=${roadItemId}`,
              let url =
                "https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/roadDetail.html?modelId=" +
                roadItemId + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
              roadJson.data.push({
                id: roadItemId + "Road",
                url: url,
                size: {
                  x: 1920,
                  y: 1080,
                },
                pos: {
                  x: Number(x),
                  y: 0,
                  z: Number(z),
                },
                scale: 100,
                pixel: 800,
                hight: 150,
                towardsCam: true,
                rotation: null,
                rotationX: null,
                isLine: true,
              });
              this.browserList.push(roadItemId);
            } else {
              OpenBrowserFunc(roadItemId + "Road");
            }
          }
        }
      );
      if (roadJson.data.length) {
        Instantiate3DUIFunc(roadJson);
      }

      if (HLJson.length) {
        RoadHeatLineFunc(JSON.stringify(HLJson));
        ShowHeatLineFunc();
      }
    },
    // 道路巡游
    getTravelRoad() {
      this.clearTimer(this.timerStop);
      this.isTravelNow = true;
      if (this.nowTravelRoad >= roadUnityFly.length) {
        this.nowTravelRoad = 0;
      }
      this.getRoundAnimate();
      LoadPathFromJSFunc(roadUnityFly[this.nowTravelRoad].json);
      this.nowTravelRoad++;
      this.timerStop = setTimeout(() => {
        this.stopTravel();
      }, 40 * 1000);
    },
    // 停止道路巡游
    stopTravel() {
      this.clearTimer(this.timerTravel);

      this.isTravelNow = false;
      StopPathFunc();
      this.timerTravel = setTimeout(() => {
        this.getTravelRoad();
      }, 15 * 1000);
    },
  },
  watch: {
    isTravelNow: {
      handler(newVal, oldVal) {
        this.clearTimer(this.timerBuilding);
        if (!newVal) {
          this.getRoundAnimate();
        }
        this.timerBuilding = setTimeout(() => {
          IsShowBuildingsFunc(String(newVal));
        }, 500);
        this.changeIsShowCarInfo(!newVal);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>